import { useAppendAdaScript } from '@interlayer/js/custom/hooks/useAdaChat';

import { useAllPlayerTags } from './hooks/useAllPlayerTags';
import { useSetCookieGroupsToPlayerTag } from './hooks/useSetCookieGroupsToPlayerTag';

export const useAfterInitHooks = () => {
    useAllPlayerTags();
    useAppendAdaScript();
    useSetCookieGroupsToPlayerTag();
};
